"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserRoleTranslationKey = exports.getUserImage = void 0;
const types_1 = require("../../shared/types");
const getUserImage = (user) => {
    if (user.picture) {
        return 'data:image;base64, ' + user.picture.toString();
    }
    return undefined;
};
exports.getUserImage = getUserImage;
const getUserRoleTranslationKey = (role) => {
    switch (role) {
        case types_1.Role.PRIMARY_USER:
            return 'weconnect.userlist.tile.overlay.table.mainUser';
        case types_1.Role.SECONDARY_USER:
            return 'weconnect.userlist.tile.overlay.table.secondaryUser';
        case types_1.Role.GUEST_USER:
            return 'weconnect.userlist.tile.overlay.table.guestUser';
        default:
            return '';
    }
};
exports.getUserRoleTranslationKey = getUserRoleTranslationKey;
//# sourceMappingURL=helper-functions.js.map